import { from } from 'rxjs';
import * as ShopAPI from './ShopAPI';

/* Get Shop Info */
export const getShopInfo = (params) => from(ShopAPI.getShopInfo(params));

/* Get Shop Address */
export const getShopAddress = (params) => from(ShopAPI.getShopAddress(params));

export const getShopDescription = (params) => from(ShopAPI.getShopDescription(params));